import React from 'react';
const Cell = props => {

	const { interval, row } = props;

	return (
		<td className="fixed-col min-width-200">
			<div className="display-flex justify-content-between">
				<div className="total-hint text-center width-33-p">{row[`${interval}-total-count`] || 0}</div>
				<div className="text-center width-33-p">
					<span className="approve-hint">{row[`${interval}-approved-count`] || 0}</span>
				</div>
				<div className="text-center width-33-p">
					<span title="Profit" className="pointer-hover">
						{
							row[`${interval}-profit`]
							&& `${Math.floor(Number(row[`${interval}-profit`]) * 100)/100} $`
						}
					</span>
				</div>
			</div>
		</td>
	);
};

export default Cell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/registration-activity/components/cell.js